import { z } from "zod"

import { validateAndParseDate } from "@/utils/dateUtils"

/**
 * URL parameter validation schemas using Zod.
 * Invalid values silently become undefined (no errors thrown).
 */

// Date param: valid YYYY-MM-DD string → Date
export const dateParamSchema = z.string().transform(validateAndParseDate)

export const parseDateParam = (rawValue: string | null): Date | undefined => {
  if (!rawValue) return undefined
  const result = dateParamSchema.safeParse(rawValue)
  return result.success && result.data ? result.data : undefined
}

// Step param: only "details" is valid
export const stepParamSchema = z.enum(["details"]).optional().catch(undefined)

export const parseStepParam = (rawValue: string | null) => {
  return stepParamSchema.parse(rawValue)
}

// Category param: non-negative integer (0 is valid)
export const categoryParamSchema = z.coerce.number().int().nonnegative()

export const parseCategoryParam = (rawValue: string | null) => {
  if (!rawValue) return undefined
  const result = categoryParamSchema.safeParse(rawValue)
  return result.success ? result.data : undefined
}

// Booking length param: non-empty string (matches BookingLength.id type)
export const bookingLengthParamSchema = z.string().min(1)

export const parseBookingLengthParam = (rawValue: string | null) => {
  if (!rawValue) return undefined
  const result = bookingLengthParamSchema.safeParse(rawValue)
  return result.success ? result.data : undefined
}
